// aristotle experiments - editable in optimizely
export const ExperimentType = {
  // https://app.optimizely.com/v2/projects/19950886887/flags/manage/holiday_ghp/rules/development
  HOLIDAY_GHP: 'holiday_ghp',

  // https://app.optimizely.com/v2/projects/19950886887/flags/manage/ai_cart_builder_external_v1/rules/development/edit/ai_cart_builder_rollout_external
  AI_CART_BUILDER_ROLLOUT_EXTERNAL: 'ai_cart_builder_rollout_external',

  // https://app.optimizely.com/v2/projects/19950886887/flags/manage/ai_cart_builder_external_v1/rules/development/edit/ai_cart_builder_rollout_internal
  AI_CART_BUILDER_ROLLOUT_INTERNAL: 'ai_cart_builder_rollout_internal',

  // https://app.optimizely.com/v2/projects/19950886887/flags/manage/buy_again_revamp/rules/development
  BUY_AGAIN_REVAMP: 'buy_again_revamp',

  // https://app.optimizely.com/v2/projects/19950886887/flags/manage/gecx_cart_builder
  GECX_CART_BUILDER_INTERNAL: 'gecx_cart_builder_internal',

  // https://app.optimizely.com/v2/projects/19950886887/flags/manage/anchor_items/rules/development
  MUST_HAVE_ITEMS: 'anchor_items',

  // https://app.optimizely.com/v2/projects/19950886887/flags/manage/order_details_product_shelf/rules/development/edit/order_details_product_shelf
  ORDER_DETAILS_PRODUCT_SHELF: 'order_details_product_shelf',

  // https://app.optimizely.com/v2/projects/19950886887/flags/manage/search_complementary_shelf/rules/production/edit/search_complementary_shelf_atc_trigger
  SEARCH_COMPLEMENTARY_SHELF: 'search_complementary_shelf_atc_trigger',

  // https://app.optimizely.com/v2/projects/19950886887/flags/manage/shared_collaborative_lists
  SHARED_COLLABORATIVE_LISTS: 'shared_collaborative_lists',

  // https://app.optimizely.com/v2/projects/19950886887/flags/manage/dynamic_stores_near_you_smaller_tiles/
  SNY_SMALLER_TILES_MOBILE: 'dynamic_stores_near_you_smaller_tiles',

  // https://app.optimizely.com/v2/projects/19950886887/flags/manage/trial_membership_upsell_optmization/rules/development
  TRIAL_MEMBERSHIP_UPSELL_OPTIMIZATION: 'trial_membership_upsell_optmization',

  // https://app.optimizely.com/v2/projects/19950886887/flags/manage/variations_enhanced_properties/rules/development
  VARIATIONS_ENHANCED_PROPERTIES: 'variations_enhanced_properties',

  // https://app.optimizely.com/v2/projects/19950886887/flags/manage/web_business_create_enabled/rules/development
  WEB_BUSINESS_CREATE_ENABLED: 'web_business_create_enabled',

  // https://app.optimizely.com/v2/projects/19950886887/flags/manage/business_profile_product_nudges_ab_test_with_custom_audience/rules/development/edit/business_profile_product_nudges_ab_test_with_custom_audience
  WEB_BUSINESS_NUDGES: 'business_profile_product_nudges_ab_test_with_custom_audience',

  // https://app.optimizely.com/v2/projects/19950886887/flags/manage/mweb_app_download_drawer_image/rules/development
  MWEB_APP_DOWNLOAD_DRAWER_IMAGE: 'mweb_app_download_drawer_image',
} as const

export type ExperimentType = (typeof ExperimentType)[keyof typeof ExperimentType]

export type ExperimentValue =
  | 'control'
  | 'variant'
  | 'variation_1'
  | 'variation_2'
  | 'variation_3'
  | 'variation'
  | 'on'
  | 'off'

export type AristotleExperiments = Record<ExperimentType, { value: ExperimentValue | undefined }>

export type AristotleResponse = {
  variations: Partial<AristotleExperiments>
}
